import * as React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.expiringRewardsClients');

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text emphasis="low" style={styles.heading} variant="subheading">
            {tt('title', 'Current Reward Balance')}
          </Text>
          <LoadingBox style={styles.loadingBoxCurrentBalance} />
        </Gutter>
        <Gutter>
          <Text variant="heading" style={styles.subheading}>
            {tt('subtitle', 'History')}
          </Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={
            <View>
              <LoadingBox style={styles.loadingBoxListItemDate} />
              <LoadingBox style={styles.loadingBoxListStatus} />
            </View>
          }
          suffix={<LoadingBox style={styles.loadingBoxHistoryBalance} />}
        />
      </Gutter>
    </View>
  );
};
